module.exports = __webpack_public_path__ + "img/x7.484cf9ef.jpg";